import { AspectRatio, Box, Heading } from '@chakra-ui/react';
import { FC } from 'react';
import PdfIcon from '../../../images/icons/pdf.svg';
import { DownloadableInterface } from '../../types/stock';

type Props = {
    downloadable: DownloadableInterface;
};

export const DownloadbleDocument: FC<Props> = ({ downloadable }) => {
    return (
        <a
            href={downloadable.url}
            download={downloadable.title}
            target="_blank"
        >
            <Box
                borderWidth={1}
                px={4}
                py={4}
                _hover={{ cursor: 'pointer', bgColor: 'gray.50' }}
            >
                <AspectRatio ratio={4 / 3} color={'secondary'}>
                    <Box>
                        <PdfIcon height={'80%'} />
                    </Box>
                </AspectRatio>
            </Box>

            {downloadable.title && (
                <Heading mt={4} size={'sm'} color={'secondary'}>
                    {downloadable.title}
                </Heading>
            )}
        </a>
    );
};
